import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';

import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


import Rocket from './rocket';

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);


const HomeHeroContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 0;
    width: 100%;
    max-width: 900px;
    flex: 1 1 0;
    @media (min-width: 800px) {
        display: block;
    }
`;

const RocketShadow = styled.div`
  position: absolute;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 90%;
  border-radius: 50%;
  background: rgba(8, 20, 0, 0.35);
  filter: blur(82px);
  z-index: 0;
  pointer-events: none;
  mix-blend-mode: multiply;
`;


interface HomeHeroProps {
    onImagesLoaded: () => void;
}

const HomeHero: React.FC<HomeHeroProps> = ( { onImagesLoaded }) => {
    const [homeHeroLoaded, setHomeHeroLoaded] = useState(true);
    const homeHeroRef = useRef<SVGSVGElement | null>(null);
    
    useEffect(() => {
        if (homeHeroLoaded) {
            onImagesLoaded();
        };
    }, [homeHeroLoaded, onImagesLoaded]);

    return (     
        <HomeHeroContainer> 
      <section style={{ position: "relative" }}>
        <Rocket ref={homeHeroRef} style={{ position: "relative" }}/>
        <RocketShadow />
      </section> 
        </HomeHeroContainer>      
    )};

export default HomeHero;